import * as Yup from "yup";

const MAX_FILE_SIZE = 20971520;

const validFileExtensions = {
  image: ["jpg", "png", "jpeg", "pdf"],
  pdf: ["pdf"],
};

function isValidFileType(fileName, fileType) {
  return (
    fileName &&
    validFileExtensions[fileType].indexOf(fileName.split(".").pop()) > -1
  );
}

function isValidVoidChequeType(fileName) {
  const validExtensions = ["pdf", "jpg", "jpeg", "png"];
  return (
    fileName &&
    validExtensions.indexOf(fileName.split(".").pop().toLowerCase()) > -1
  );
}

const getCharacterValidationError = (str) => {
  return `Require at least 1 ${str} character`;
};

export const contactFormValidationSchema = Yup.object({
  subject: Yup.string().required("This is a required field"),
  // cardnumber: Yup.string().when("subject", {
  //   is: "Canco Cash Loyalty / Mobile App",
  //   then: () => Yup.string().required("This is a required field"),
  // }),
  name: Yup.string().required("This is a required field"),
  message: Yup.string().required("This is a required field"),
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  attachment: Yup.mixed()
    .test(
      "is-valid-type",
      "Upload valid image (.png, .jpg, .jpeg) or pdf",
      (value) =>
        value
          ? isValidFileType(value && value.name.toLowerCase(), "image")
          : true
    )
    .test("is-valid-size", "Max allowed size is 5MB", (value) => {
      // console.log("photo size", value);
      if (!value) return true;
      return value && value.size <= 5242880;
    }),
  related_to_store: Yup.object().required("Location is Required"),
});

export const signupFormValidationSchema = Yup.object({
  first_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  last_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  confirmEmail: Yup.string()
    .email("Enter a valid email")
    .required("This is a required field")
    .oneOf([Yup.ref("email")], "Email does not match"),
  phone: Yup.string()
    .required("This is a required field")
    .min(14, "Minimum 10 digits required."),
  password: Yup.string()
    .required("This is a required field")
    .min(8, "Require at least 8 characters")
    .matches(/[0-9]/, getCharacterValidationError("digit"))
    .matches(/[a-z]/, getCharacterValidationError("lowercase"))
    .matches(/[A-Z]/, getCharacterValidationError("uppercase"))
    .matches(/[!@#$%^&*(),.?":{}|<>]/, getCharacterValidationError("special")),
  confirmPassword: Yup.string()
    .required("This is a required field")
    .oneOf([Yup.ref("password")], "Passwords does not match"),
  t_and_c_accepted: Yup.bool().oneOf(
    [true],
    "You need to accept the terms and conditions"
  ),
  dob: Yup.string()
    .test("is-valid-date", "Invalid date", function (value) {
      if (!value) return true;

      const [year, month, day] = value.split("-").map(Number);

      // Ensure the year is within a reasonable range (e.g., not less than 1900)
      if (year < 1900 || year >= new Date().getFullYear()) {
        return false;
      }

      // Ensure the month is between 1 and 12
      if (month < 1 || month > 12) {
        return false;
      }

      // Ensure the day is valid for the given month
      const daysInMonth = new Date(year, month, 0).getDate(); // Gets the last day of the month
      return day >= 1 && day <= daysInMonth;
    })
    .test("not-future-date", "Invalid date", function (value) {
      if (!value) return true;

      const today = new Date();
      const enteredDate = new Date(value);

      console.log("future date", enteredDate <= today);

      // Ensure the entered date is not in the future
      return enteredDate <= today;
    })
    .nullable(),
});

export const signupCardValidationSchema = Yup.object({
  cardnumber: Yup.string()
    .matches(/^\d+$/, "Enter only number")
    .test("notStartsWith1234", "Gift card is not allowed", (value) => {
      return !value.startsWith("604958");
    })
    .required("Card number is required"),
  access_code: Yup.string()
  .required("This is a required field")
  .matches(/^[\d-]+$/, "Only numbers and dash are allowed")
  .max(11, "Maximum 11 characters allowed")
  .test("valid-dash-count", "Only one dash is allowed", (value) => {
    if (!value) return true;
    const dashCount = (value.match(/-/g) || []).length;
    return dashCount <= 1;
  }),
  first_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  last_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  confirmEmail: Yup.string()
    .email("Enter a valid email")
    .required("This is a required field")
    .oneOf([Yup.ref("email")], "Email does not match"),
  phone: Yup.string()
    .required("This is a required field")
    .min(14, "Minimum 10 digits required."),
  password: Yup.string()
    .required("This is a required field")
    .min(8, "Require at least 8 characters")
    .matches(/[0-9]/, getCharacterValidationError("digit"))
    .matches(/[a-z]/, getCharacterValidationError("lowercase"))
    .matches(/[A-Z]/, getCharacterValidationError("uppercase"))
    .matches(/[!@#$%^&*(),.?":{}|<>]/, getCharacterValidationError("special")),
  confirmPassword: Yup.string()
    .required("This is a required field")
    .oneOf([Yup.ref("password")], "Passwords does not match"),
  t_and_c_accepted: Yup.bool().oneOf(
    [true],
    "You need to accept the terms and conditions"
  ),
  dob: Yup.string()
    .nullable()
    .test("is-valid-date", "Invalid date", function (value) {
      if (!value) return true;

      const [year, month, day] = value.split("-").map(Number);

      // Ensure the year is within a reasonable range (e.g., not less than 1900)
      if (year < 1900 || year >= new Date().getFullYear()) {
        return false;
      }

      // Ensure the month is between 1 and 12
      if (month < 1 || month > 12) {
        return false;
      }

      // Ensure the day is valid for the given month
      const daysInMonth = new Date(year, month, 0).getDate(); // Gets the last day of the month
      return day >= 1 && day <= daysInMonth;
    })
    .test("not-future-date", "Invalid date", function (value) {
      if (!value) return true;

      const today = new Date();
      const enteredDate = new Date(value);

      console.log("future date", enteredDate <= today);

      // Ensure the entered date is not in the future
      return enteredDate <= today;
    }),
});

export const resetPasswordValidationSchema = Yup.object({
  password: Yup.string()
    .required("This is a required field")
    .min(8, "Require at least 8 characters")
    .matches(/[0-9]/, getCharacterValidationError("digit"))
    .matches(/[a-z]/, getCharacterValidationError("lowercase"))
    .matches(/[A-Z]/, getCharacterValidationError("uppercase"))
    .matches(/[!@#$%^&*(),.?":{}|<>]/, getCharacterValidationError("special")),
  confirmPassword: Yup.string()
    .required("This is a required field")
    .oneOf([Yup.ref("password")], "Passwords does not match"),
});

export const addCardValidationSchema = Yup.object({
  cardnumber: Yup.string()
    .matches(/^\d+$/, "Card number must contain only digits")
    .test("notStartsWith1234", "Only loyalty card allowed", (value) => {
      return value.startsWith("637738") || value.startsWith("612573");
    })
    .required("Card number is required"),
  ackroo_id: Yup.string()
    .required("This is a required field")
    .matches(/^[\d-]+$/, "Only numbers and dash are allowed")
    .max(11, "Maximum 11 characters allowed")
    .test("valid-dash-count", "Only one dash is allowed", (value) => {
      if (!value) return true;
      const dashCount = (value.match(/-/g) || []).length;
      return dashCount <= 1;
    }),
});

export const balanceTransferValidationSchema = Yup.object({
  from_card_number: Yup.string().required("This is a required field"),
  to_card_number: Yup.string().required("This is a required field"),
});

export const dealerFormValidationSchema = Yup.object({
  first_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed")
    .max(15, "Maximum 15 characters allowed"),
  last_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed")
    .max(15, "Maximum 15 characters allowed"),
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  phone: Yup.string()
    .required("This is a required field")
    .matches(/^\d{3}-\d{3}-\d{4}$/, "Phone format must be xxx-xxx-xxxx")
    .test("phone-digits", "Phone number must contain exactly 10 digits", function(value) {
      if (!value) return false;
      const digits = value.replace(/[^\d]/g, "");
      return digits.length === 10;
    }),
  option_applies: Yup.array()
    .min(1, "Please select at least one option")
    .required("This is a required field"),
  gas_station_brand: Yup.string().when("option_applies", {
    is: (options) => options && options.includes("own_operate_gas_station"),
    then: () => Yup.string()
      .required("This is a required field")
      .test("max-words", "Maximum 5 words allowed", function(value) {
        if (!value) return true;
        const words = value.trim().split(/\s+/).filter(word => word.length > 0);
        return words.length <= 5;
      }),
  }),
  property_details: Yup.string().when("option_applies", {
    is: (options) => options && options.includes("own_property"),
    then: () => Yup.string()
      .required("This is a required field")
      .test("max-words", "Maximum 200 words allowed", function(value) {
        if (!value) return true;
        const words = value.trim().split(/\s+/).filter(word => word.length > 0);
        return words.length <= 200;
      }),
  }),
  property_info: Yup.string()
    .required("This is a required field")
    .test("max-words", "Maximum 200 words allowed", function(value) {
      if (!value) return true;
      const words = value.trim().split(/\s+/).filter(word => word.length > 0);
      return words.length <= 200;
    }),
  lot_area_frontage: Yup.string()
    .required("This is a required field")
    .matches(/^\d+$/, "Only numbers are allowed"),
  on_site_businesses: Yup.array()
    .when("option_applies", {
      is: (options) => options && options.includes("own_operate_gas_station"),
      then: () => Yup.array()
        .min(1, "Please select at least one option")
        .required("This is a required field"),
      otherwise: () => Yup.array().notRequired(),
    }),
  qsr_brand: Yup.string().when("on_site_businesses", {
    is: (options) => options && options.includes("qsr"),
    then: () => Yup.string().required("Please specify the QSR brand"),
  }),
  others_specify: Yup.string().when("on_site_businesses", {
    is: (options) => options && options.includes("others"),
    then: () => Yup.string()
      .required("Please specify")
      .max(200, "Maximum 200 characters allowed"),
  }),
  fsa_in_place: Yup.string().when("option_applies", {
    is: (options) => options && options.includes("own_operate_gas_station"),
    then: () => Yup.string()
      .required("This is a required field")
      .oneOf(["yes", "no"], "Please select Yes or No"),
    otherwise: () => Yup.string().notRequired(),
  }),
  fsa_expiry_date: Yup.string().when("fsa_in_place", {
    is: "yes",
    then: () => Yup.string().required("Please provide the FSA expiry date"),
    otherwise: () => Yup.string().notRequired(),
  }),
  property_zoning: Yup.string().when("option_applies", {
    is: (options) => options && options.includes("own_property"),
    then: () => Yup.string()
      .required("This is a required field")
      .oneOf(["yes", "no"], "Please select Yes or No"),
    otherwise: () => Yup.string().notRequired(),
  }),
});

export const retailAgentFormValidationSchema = Yup.object({
  first_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed")
    .max(15, "Maximum 15 characters allowed"),
  last_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed")
    .max(15, "Maximum 15 characters allowed"),
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  phone: Yup.string()
    .required("This is a required field")
    .matches(/^\d{3}-\d{3}-\d{4}$/, "Phone format must be xxx-xxx-xxxx")
    .test("phone-digits", "Phone number must contain exactly 10 digits", function(value) {
      if (!value) return false;
      const digits = value.replace(/[^\d]/g, "");
      return digits.length === 10;
    }),
  message: Yup.string()
    .required("This is a required field")
    .max(250, "Maximum 250 characters allowed"),
  canadian_citizenship_or_pr: Yup.string()
    .required("This is a required field")
    .oneOf(["yes", "no"], "Please select Yes or No"),
  previous_experience: Yup.string()
    .required("This is a required field")
    .test("max-words", "Maximum 200 words allowed", function(value) {
      if (!value) return true;
      const words = value.trim().split(/\s+/).filter(word => word.length > 0);
      return words.length <= 200;
    }),
  funding_overview: Yup.string()
    .required("This is a required field")
    .max(250, "Maximum 250 characters allowed"),
  total_investment_amount: Yup.string()
    .required("This is a required field")
    .matches(/^\d+$/, "Only numbers are allowed"),
  support_in_running_site: Yup.string()
    .required("This is a required field")
    .oneOf(["yes", "no"], "Please select Yes or No"),
  support_details: Yup.string().when("support_in_running_site", {
    is: "yes",
    then: () => Yup.string()
      .required("Please provide details")
      .max(100, "Maximum 100 characters allowed"),
    otherwise: () => Yup.string().notRequired(),
  }),
  preferred_geographical_area: Yup.string()
    .required("This is a required field")
    .max(100, "Maximum 100 characters allowed"),
  willing_to_participate_training: Yup.string()
    .required("This is a required field")
    .oneOf(["yes", "no"], "Please select Yes or No"),
  referral_available: Yup.string()
    .required("This is a required field")
    .oneOf(["yes", "no"], "Please select Yes or No"),
  referral_details: Yup.string().when("referral_available", {
    is: "yes",
    then: () => Yup.string()
      .required("Please provide referral details")
      .max(100, "Maximum 100 characters allowed"),
    otherwise: () => Yup.string().notRequired(),
  }),
});

export const realtorFormValidationSchema = Yup.object({
  first_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  last_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  company_name: Yup.string().required("This is a required field"),
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  phone: Yup.string()
    .required("This is a required field")
    .min(14, "Minimum 10 digits required."),
  offering_lease_or_purchase: Yup.string().required("This is a required field"),
  address: Yup.string().required("This is a required field"),
  size_of_property: Yup.string().required("This is a required field"),
  zoning: Yup.string().required("This is a required field"),
  attachment: Yup.mixed().required("This is a required field"),
});

export const vendorStepOneValidationSchema = Yup.object({
  first_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  last_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  phone: Yup.string()
    .required("This is a required field")
    .min(14, "Minimum 10 digits required."),
  focused_product: Yup.string().required("This is a required field"),
  company_name: Yup.string().required("This is a required field"),
  distribution_model: Yup.string().required("This is a required field"),
});

export const vendorStepTwoValidationSchema = Yup.object({
  edi_capabilities: Yup.string().required("This is a required field"),
  minimum_order_levels: Yup.string().required("This is a required field"),
  how_to_order: Yup.string().required("This is a required field"),
  product_guarantee: Yup.string().required("This is a required field"),
  distribution_reach: Yup.string().required("This is a required field"),
  attachment: Yup.mixed()
    .test(
      "is-valid-type",
      "Upload valid image (.png, .jpg, .jpeg) or pdf",
      (value) =>
        value
          ? isValidFileType(value && value.name.toLowerCase(), "image")
          : true
    )
    .test("is-valid-size", "Max allowed size is 20MB", (value) => {
      // console.log("photo size", value);
      if (!value) return true;
      return value && value.size <= MAX_FILE_SIZE;
    }),
});

export const fleetMemberStepOneValidationSchema = Yup.object({
  business_name: Yup.string().required("This is a required field"),
  business_number: Yup.string().required("This is a required field"),
  business_type: Yup.string().required("This is a required field"),
  years_of_company: Yup.string().required("This is a required field"),
  years_of_operation: Yup.string().required("This is a required field"),
  hst_exempt: Yup.string().required("This is a required field"),
  hst_exempt_document: Yup.mixed().when("hst_exempt", {
    is: "yes",
    then: () =>
      Yup.mixed()
        .required("This is a required field")
        .test("is-valid-type", "Upload valid PDF file (.pdf)", (value) =>
          value ? isValidFileType(value.name.toLowerCase(), "pdf") : false
        ),
    otherwise: () => Yup.mixed(),
  }),
  gst_number: Yup.string().when("hst_exempt", {
    is: "no",
    then: () => Yup.string().required("This is a required field"),
    otherwise: () => Yup.string(),
  }),
});

export const fleetMemberStepTwoValidationSchema = Yup.object({
  street: Yup.string().required("This is a required field"),
  city: Yup.string().required("This is a required field"),
  province: Yup.string().required("This is a required field"),
  postcode: Yup.string().required("This is a required field"),
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  business_phone: Yup.string().required("This is a required field"),
  cell: Yup.string().required("This is a required field"),
});

export const fleetMemberStepThreeValidationSchema = Yup.object({
  contact_person: Yup.string().required("This is a required field"),
  title: Yup.string().required("This is a required field"),
  contact_person_phone: Yup.string().required("This is a required field"),
  contact_person_email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  contact_person_confirm_email: Yup.string()
    .email("Enter valid email")
    .required("This is a required field")
    .oneOf([Yup.ref("contact_person_email")], "Email does not match"),
});

export const fleetMemberStepFourValidationSchema = Yup.object({
  business_name: Yup.string().required("This is a required field"),
  first_name: Yup.string().required("This is a required field"),
  last_name: Yup.string().required("This is a required field"),
  // dob: Yup.date().required("This is a required field"),
  street: Yup.string().required("This is a required field"),
  // apartment: Yup.string().required("This is a required field"),
  city: Yup.string().required("This is a required field"),
  province: Yup.string().required("This is a required field"),
  postcode: Yup.string().required("This is a required field"),
  title: Yup.string().required("This is a required field"),
  contact_email: Yup.string()
    .email("Enter valid email")
    .required("This is a required field"),
  contact_personal_phone: Yup.string().required("This is a required field"),
  contact_business_phone: Yup.string().required("This is a required field"),
  // sin: Yup.string().required("This is a required field"),
});

export const fleetMemberStepFiveValidationSchema = Yup.object({
  financial_institution: Yup.string().required("This is a required field"),
  branch: Yup.string().required("This is a required field"),
  street: Yup.string().required("This is a required field"),
  // apartment: Yup.string().required("This is a required field"),
  city: Yup.string().required("This is a required field"),
  province: Yup.string().required("This is a required field"),
  first_name: Yup.string().required("This is a required field"),
  last_name: Yup.string().required("This is a required field"),
  phone: Yup.string().required("This is a required field"),
  account_number: Yup.string().required("This is a required field"),
  void_cheque: Yup.mixed()
    .required("This is a required field")
    .test(
      "is-valid-type",
      "Upload valid file (.pdf, .jpg, .jpeg, .png)",
      (value) => (value ? isValidVoidChequeType(value.name) : false)
    ),
});

export const loginValidationSchema = Yup.object({
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  password: Yup.string().required("This is a required field"),
});

export const loginCardValidationSchema = Yup.object({
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  password: Yup.string().required("This is a required field"),
});

export const editUserProfileValidationSchema = Yup.object({
  first_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  last_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  phone: Yup.string()
    .required("This is a required field")
    .min(14, "Minimum 10 digits required."),
});

export const missingPointsValidationSchema = Yup.object({
  firstName: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  lastName: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  // email: Yup.string()
  //   .email("Email is not valid")
  //   .required("This is a required field"),
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  cardNumber: Yup.string().required("This is a required field"),
  transactionNumber: Yup.string().required("This is a required field"),
  uploadReceipt: Yup.mixed().required("This is a required field"),
});

export const schoolSpiritValidationSchema = Yup.object({
  first_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  last_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed "),
  phone_number: Yup.string()
    .required("This is a required field")
    .min(14, "Minimum 10 digits required."),
  // email: Yup.string()
  //   .email("Email is not valid")
  //   .required("This is a required field"),
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  card_number: Yup.string()
    .matches(/^\d+$/, "Card number must contain only digits")
    .test("notStartsWith1234", "Only loyalty card allowed", (value) => {
      console.log("card val", value);
      return value.startsWith("637738") || value.startsWith("612573");
    })
    .required("Card number is required"),
  school_name: Yup.string().required("This is a required field"),
  school_city: Yup.object().required("This is a required field"),
  school_province: Yup.object().required("This is a required field"),
});

export const surveyValidationSchema = Yup.object({
  overall_experience: Yup.string().required("This is a required field"),
  enviornment: Yup.string().required("This is a required field"),
  merchandise: Yup.string().required("This is a required field"),
  service_experience: Yup.string().required("This is a required field"),
  loyalty_card: Yup.string().required("This is a required field"),
});

export const accountDeletionValidationSchema = Yup.object({
  is_agree: Yup.bool().oneOf(
    [true],
    "You need to accept the terms and conditions"
  ),
});

export const typeDeleteValidationSchema = Yup.object({
  name: Yup.string()
    .oneOf(
      ["DELETE"],
      "Sorry, please enter the text exactly as displayed to confirm"
    )
    .required("This field is required"),
});

export const wholesaleBusinessContactFormValidationSchema = Yup.object({
  name: Yup.string().required("This is a required field"),
  phone: Yup.string()
    // .required("This is a required field")
    .min(14, "Minimum 10 digits required."),
  email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Invalid email format")
    .required("This is a required field"),
  // email: Yup.string()
  //   .email("Invalid email")
  //   .required("This is a required field"),
  message: Yup.string().required("This is a required field"),
});

export const xpressCardlockApplicationValidationSchema = Yup.object({
  // Section 1 - Business Information
  card_applying_for: Yup.string().required("This is a required field"),
  customer_type: Yup.string().required("This is a required field"),
  customer_type_other: Yup.string().when("customer_type", {
    is: "others",
    then: () => Yup.string().required("This is a required field"),
    otherwise: () => Yup.string(),
  }),
  hear_about_canco: Yup.string().required("This is a required field"),
  hear_about_canco_other: Yup.string().when("hear_about_canco", {
    is: (val) => val === "referral" || val === "others",
    then: () => Yup.string().required("This is a required field"),
    otherwise: () => Yup.string(),
  }),
  financial_statement: Yup.mixed(),
  legal_business_name: Yup.string().required("This is a required field"),
  trade_name_dba: Yup.string(),
  business_structure: Yup.string().required("This is a required field"),
  years_in_business: Yup.string().required("This is a required field"),
  // Section 2 - Contact Information
  business_number: Yup.string().required("This is a required field"),
  gst_tax_exempt_number: Yup.string(),
  business_mailing_address: Yup.string().required("This is a required field"),
  contact_person_full_name: Yup.string()
    .required("This is a required field")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed"),
  contact_person_title: Yup.string().required("This is a required field"),
  contact_person_email: Yup.string()
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
    .required("This is a required field"),
  contact_person_phone: Yup.string()
    .required("This is a required field")
    .matches(/^\d{3}-\d{3}-\d{4}$/, "Phone number must be in format xxx-xxx-xxxx"),
  // Section 3 - Fleet Information
  fleet_size: Yup.string().required("This is a required field"),
  total_anticipated_volume: Yup.string()
    .required("This is a required field")
    .matches(/^\d+$/, "Only numeric values are allowed"),
  number_of_cards: Yup.string()
    .required("This is a required field")
    .matches(/^\d+$/, "Only numeric values are allowed"),
  average_transaction: Yup.string()
    .required("This is a required field")
    .matches(/^\d+(\.\d+)?$/, "Only numeric values are allowed"),
  average_transactions_per_day: Yup.string()
    .required("This is a required field")
    .matches(/^\d+$/, "Only numeric values are allowed"),
  preferred_cardlock_location: Yup.string().when("card_applying_for", {
    is: (val) => val === "canco_cardlock" || val === "both",
    then: () => Yup.string().required("This is a required field"),
    otherwise: () => Yup.string(),
  }),
  price_notifications: Yup.boolean(),
  price_notification_email: Yup.string().when("price_notifications", {
    is: true,
    then: () =>
      Yup.string()
        .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Email is not valid")
        .required("This is a required field"),
    otherwise: () => Yup.string(),
  }),
  // Section 4 - Banking Reference
  banking_institution_name: Yup.string().required("This is a required field"),
  transit_number: Yup.string()
    .required("This is a required field")
    .matches(/^\d+$/, "Only numeric values are allowed"),
  institution_number: Yup.string()
    .required("This is a required field")
    .matches(/^\d+$/, "Only numeric values are allowed"),
  account_number: Yup.string()
    .required("This is a required field")
    .matches(/^\d+$/, "Only numeric values are allowed"),
  void_cheque: Yup.mixed().required("This is a required field"),
  // Acknowledgement
  acknowledgement: Yup.bool().oneOf(
    [true],
    "You need to accept the Terms and Conditions"
  ),
});